import { useState } from 'react';
import { useEffect } from 'react';
import { Modal, Form, Row, Col, Tab, Tabs, Collapse } from 'react-bootstrap';
import { getCommodityDetail } from '../apiCalls';
import { Input, TextArea } from '../Input/Input';
import { removeHtmlTags } from '../../utils/stringUtils';

const CommodityModal = ({ onClose, commodity, measure }) => {
  const [commodityData, setCommodityData] = useState([]);
  const [requestFailed, setRequestFailed] = useState(false);

  useEffect(() => {
    if (!commodity?.cId) {
      setCommodityData({});
      return;
    }
    async function fetchData() {
      try {
        const data = await getCommodityDetail(commodity.cId);
        setCommodityData(data.Parents[0]);
      } catch {
        setRequestFailed(true);
      }
    }
    fetchData();
  }, [commodity?.cId]);

  if (!commodity?.cId) {
    return null;
  }

  return (
    <Modal
      show={commodity?.cId !== undefined}
      onHide={onClose}
      centered
      size="lg"
      contentClassName="editModal"
      dialogClassName="wide-modal"
      className="dataEnrichment"
    >
      <Modal.Header>
        <Modal.Title>Viewing: {commodity.commCode}</Modal.Title>{' '}
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
      </Modal.Header>
      <Form className="flex-grow-1 d-flex flex-column">
        {commodity.mId !== -1 && <input type="hidden" name="id" value={commodity.cId} />}
        <Modal.Body className="flex-grow-1">
          <Tabs>
            <Tab title="Commodity Data" eventKey="importcontrols">
              <section className="p-2 d-flex flex-column">
                <Row>
                  <Col>
                    <Input value={commodityData.commCodeDesc} label={'Commodity Description'} disabled />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input value={removeHtmlTags(commodityData.commDuty)} label={'Duty'} disabled />
                  </Col>
                  <Col>
                    <Input value={commodityData.commVAT} label={'VAT'} disabled />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextArea
                      rows={10}
                      style={{ resize: 'none', maxHeight: '800px' }}
                      value={commodityData.chapterNotes}
                      label={'Chapter Notes'}
                      disabled
                    />
                  </Col>
                </Row>
              </section>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer
          class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-end align-items-center"
          style={{
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
          }}
        >
          <button type="submit" onClick={onClose} class="blue-button-teams green-btn" style={{ borderRadius: '10px' }}>
            Close
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default CommodityModal;
